import LcabApiRequest from "~/cabinet/ts/api/LcabApiRequest";
import AbstractEntity, {AbstractEntityFields} from "~/ts/library/AbstractEntity";
import Auth from "~/cabinet/ts/data/integrations/Auth";
import {PlatformInterface} from "~/cabinet/ts/data/integrations/Platform";

export default async function getAuthById(authId: string) {
    return await (new LcabApiRequest({
        url: `/api/client/integration/getAuthById/${authId}`
    }, GetAuthByIdResponse)).send()
}

export function getAuthByPrimaryIdRequest(platformId: string, authPrimaryId: string, siteId: string) {
    return new LcabApiRequest({
        url: `/api/client/integration/getAuthByPrimaryId/${platformId}/${authPrimaryId}/${siteId}`
    }, GetAuthByIdResponse);
}

class GetAuthByIdResponse extends AbstractEntity {
    auth: Auth;
    platform: PlatformInterface;

    protected getFields(): AbstractEntityFields {
        return {
            auth: Auth
        };
    }
}